const ProjectPlanning = ({
  formData,
  setFormData,
}) => {

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="space-y-6">

      <div>
        <h3 className="text-xl font-bold text-slate-800">
          Project Planning
        </h3>

        <p className="mt-1 text-sm text-slate-500">
          Configure project dates, estimates and planning information.
        </p>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-6">

        <div className="grid grid-cols-2 gap-5">

          {/* Start Date */}

          <div>
            <label className="text-sm font-medium text-slate-700">
              Planned Start Date
            </label>

            <input
              type="date"
              name="planned_start_date"
              value={formData.planned_start_date}
              onChange={handleChange}
              className="mt-2 w-full rounded-lg border border-slate-300 px-4 py-2.5"
            />
          </div>

          {/* End Date */}

          <div>
            <label className="text-sm font-medium text-slate-700">
              Planned End Date
            </label>

            <input
              type="date"
              name="planned_end_date"
              value={formData.planned_end_date}
              onChange={handleChange}
              className="mt-2 w-full rounded-lg border border-slate-300 px-4 py-2.5"
            />
          </div>

          {/* Estimated Hours */}

          <div>
            <label className="text-sm font-medium text-slate-700">
              Estimated Hours
            </label>

            <input
              type="number"
              min="0"
              name="estimated_hours"
              value={formData.estimated_hours}
              onChange={handleChange}
              placeholder="500"
              className="mt-2 w-full rounded-lg border border-slate-300 px-4 py-2.5"
            />
          </div>

          {/* Estimated Cost */}

          <div>
            <label className="text-sm font-medium text-slate-700">
              Estimated Cost
            </label>

            <input
              type="number"
              min="0"
              name="estimated_cost"
              value={formData.estimated_cost}
              onChange={handleChange}
              placeholder="100000"
              className="mt-2 w-full rounded-lg border border-slate-300 px-4 py-2.5"
            />
          </div>

        </div>

      </div>

    </div>
  );
};

export default ProjectPlanning;